"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _DirectDebitDetails = _interopRequireDefault(require("./DirectDebitDetails"));
var _PaymentCardDetails = _interopRequireDefault(require("./PaymentCardDetails"));
var _TokenizedCardDetails = _interopRequireDefault(require("./TokenizedCardDetails"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The RecurringPaymentDetails model module.
 * @module model/RecurringPaymentDetails
 * @version 3.0
 */
var RecurringPaymentDetails = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>RecurringPaymentDetails</code>.
   * @alias module:model/RecurringPaymentDetails
   */
  function RecurringPaymentDetails() {
    _classCallCheck(this, RecurringPaymentDetails);
    RecurringPaymentDetails.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(RecurringPaymentDetails, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>RecurringPaymentDetails</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RecurringPaymentDetails} obj Optional instance to populate.
     * @return {module:model/RecurringPaymentDetails} The populated <code>RecurringPaymentDetails</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new RecurringPaymentDetails();
        if (data.hasOwnProperty('directDebitDetails')) {
          obj['directDebitDetails'] = _DirectDebitDetails["default"].constructFromObject(data['directDebitDetails']);
        }
        if (data.hasOwnProperty('creditCardDetails')) {
          obj['creditCardDetails'] = _PaymentCardDetails["default"].constructFromObject(data['creditCardDetails']);
        }
        if (data.hasOwnProperty('debitCardDetails')) {
          obj['debitCardDetails'] = _PaymentCardDetails["default"].constructFromObject(data['debitCardDetails']);
        }
        if (data.hasOwnProperty('tokenizedCardDetails')) {
          obj['tokenizedCardDetails'] = _TokenizedCardDetails["default"].constructFromObject(data['tokenizedCardDetails']);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>RecurringPaymentDetails</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RecurringPaymentDetails</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // validate the optional field `directDebitDetails`
      if (data['directDebitDetails']) {
        // data not null
        _DirectDebitDetails["default"].validateJSON(data['directDebitDetails']);
      }
      // validate the optional field `creditCardDetails`
      if (data['creditCardDetails']) {
        // data not null
        _PaymentCardDetails["default"].validateJSON(data['creditCardDetails']);
      }
      // validate the optional field `debitCardDetails`
      if (data['debitCardDetails']) {
        // data not null
        _PaymentCardDetails["default"].validateJSON(data['debitCardDetails']);
      }
      // validate the optional field `tokenizedCardDetails`
      if (data['tokenizedCardDetails']) {
        // data not null
        _TokenizedCardDetails["default"].validateJSON(data['tokenizedCardDetails']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {module:model/DirectDebitDetails} directDebitDetails
 */
RecurringPaymentDetails.prototype['directDebitDetails'] = undefined;

/**
 * @member {module:model/PaymentCardDetails} creditCardDetails
 */
RecurringPaymentDetails.prototype['creditCardDetails'] = undefined;

/**
 * @member {module:model/PaymentCardDetails} debitCardDetails
 */
RecurringPaymentDetails.prototype['debitCardDetails'] = undefined;

/**
 * @member {module:model/TokenizedCardDetails} tokenizedCardDetails
 */
RecurringPaymentDetails.prototype['tokenizedCardDetails'] = undefined;
var _default = exports["default"] = RecurringPaymentDetails;